import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import AppLayout from "./Layouts/AppLayout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CreateBooking from "./pages/CreateBooking";
import ProtectedRoute from "./components/ProtectedRoute";

const Dashboard = lazy(() => import("./pages/Dashboard"));
const Users = lazy(() => import("./pages/Users"));
const RolesPermissions = lazy(() => import("./pages/RolesPermissions"));
const Drivers = lazy(() => import("./pages/Drivers"));
const VehiclesMaster = lazy(() => import("./pages/VehiclesMaster"));
const Enterprises = lazy(() => import("./pages/Enterprises"));
const FarePlans = lazy(() => import("./pages/FarePlans"));
const Packages = lazy(() => import("./pages/Packages"));
const Cities = lazy(() => import("./pages/Cities"));
const CommsTemplates = lazy(() => import("./pages/CommsTemplates"));
const Bookings = lazy(() => import("./pages/Bookings"));
const Invoices = lazy(() => import("./pages/Invoices"));
const Reports = lazy(() => import("./pages/Reports"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy.jsx"));

const Loader = () => <div className="p-6 text-mute">Loading...</div>;

function LazyPage({ component: Component }) {
  return (
    <Suspense fallback={<Loader />}>
      <Component />
    </Suspense>
  );
}

function ProtectedPage({ component: Component, roles = [] }) {
  return (
    <ProtectedRoute requiredRoles={roles}>
      {() => (
        <Suspense fallback={<Loader />}>
          <Component />
        </Suspense>
      )}
    </ProtectedRoute>
  );
}

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        {}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {}
        <Route path="/" element={<AppLayout />}>
          <Route index element={<Navigate to="/packages" replace />} />

          <Route path="dashboard" element={<LazyPage component={Dashboard} />} />

          {}
          <Route path="users" element={<ProtectedPage component={Users} roles={["SUPER_ADMIN", "ADMIN"]} />} />
          <Route path="permissions" element={<ProtectedPage component={RolesPermissions} roles={["SUPER_ADMIN", "ADMIN"]} />} />
          <Route path="city" element={<ProtectedPage component={Cities} roles={["SUPER_ADMIN", "ADMIN"]} />} />
          <Route path="drivers" element={<ProtectedPage component={Drivers} roles={["SUPER_ADMIN", "ADMIN"]} />} />
          <Route path="vehicles" element={<ProtectedPage component={VehiclesMaster} roles={["SUPER_ADMIN", "ADMIN"]} />} />
          <Route path="vehicle-categories" element={<Navigate to="/vehicles?tab=categories" replace />} />
          <Route path="packages" element={<ProtectedPage component={Packages} roles={["SUPER_ADMIN", "ADMIN"]} />} />

          {}
          <Route path="enterprises" element={<LazyPage component={Enterprises} />} />
          <Route path="pricing" element={<LazyPage component={FarePlans} />} />
          <Route path="comms-templates" element={<ProtectedPage component={CommsTemplates} roles={["SUPER_ADMIN", "ADMIN"]} />} />
          <Route path="bookings" element={<LazyPage component={Bookings} />} />
          <Route path="create-booking" element={<LazyPage component={CreateBooking} />} />
          <Route path="invoices" element={<LazyPage component={Invoices} />} />
          <Route path="reports" element={<LazyPage component={Reports} />} />
          <Route path="privacy-policy" element={<LazyPage component={PrivacyPolicy} />} />
        </Route>

        {}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
